import { FaBookOpen, FaBolt, FaBullhorn, FaRegComments } from "react-icons/fa6";
import type { ComponentType, SVGProps } from "react";
import type { SpotName, SpotTone } from "../Spot/SpotIcon";

export const CATEGORIES = ["guides", "productivite", "actualites", "temoignages"] as const;
export type Category = (typeof CATEGORIES)[number];

export const CATEGORY_META: Record<
  Category,
  {
    labelKey: string;
    descKey: string;
    color: string;
    bg: string;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
    /** Illustrated icon and its tile colour, for the Resources hub. */
    spot: SpotName;
    tone: SpotTone;
  }
> = {
  guides: {
    labelKey: "ressources.category.guides.label",
    descKey: "ressources.category.guides.desc",
    // Text-safe inks: these colour the category pills (small text on their tint).
    color: "text-brand-ink",
    bg: "bg-blue-ulight",
    Icon: FaBookOpen,
    spot: "guides",
    tone: "blue",
  },
  productivite: {
    labelKey: "ressources.category.productivite.label",
    descKey: "ressources.category.productivite.desc",
    color: "text-funpurple",
    bg: "bg-funpurple-ter",
    Icon: FaBolt,
    spot: "productivite",
    tone: "purple",
  },
  actualites: {
    labelKey: "ressources.category.actualites.label",
    descKey: "ressources.category.actualites.desc",
    color: "text-funblue",
    bg: "bg-funblue-ter",
    Icon: FaBullhorn,
    spot: "actualites",
    tone: "navy",
  },
  temoignages: {
    labelKey: "ressources.category.temoignages.label",
    descKey: "ressources.category.temoignages.desc",
    color: "text-green-ink",
    bg: "bg-green-ulight",
    Icon: FaRegComments,
    spot: "temoignages",
    tone: "green",
  },
};
